import {motion} from 'framer-motion';
import Card from "../shared/Card";
import GeneralContext from '../../context/GeneralContext';
import { useContext } from 'react';
import ButtonFunction from '../shared/ButtonFunction';
import { GiCutDiamond } from "react-icons/gi";

function ManagePoints() {

    const { changeCurrentMenu } = useContext(GeneralContext);

    return (
      <motion.div
        key='adminManagePoints'
        initial={{opacity: 0, x: -1000}}
        animate={{opacity: 1, x: 0}}
        exit={{opacity: 0, x: -1000, transition:{duration: 0.5, delay: 0}}}
        transition={{duration: 0.5}}>
          <Card>
            <GiCutDiamond size='50px'/>
            <h1>Gestionar Puntos</h1>
            <ButtonFunction
              buttonFunction={changeCurrentMenu}
              buttonArguments={'adjust-points'}
              buttonClass='adminButton'
            >
              Ajustar Puntos
            </ButtonFunction>
            <br />
            <br />
            <ButtonFunction 
              buttonFunction={changeCurrentMenu}
              buttonArguments={'users-points'}
              buttonClass='adminButton'
            >
              Historial de Puntos por Usuario
            </ButtonFunction>
            <br />
            <br />
            <ButtonFunction 
              buttonFunction={changeCurrentMenu}
              buttonArguments={'reset-points'}
              buttonClass='adminButton'
            >
              Restablecer Puntos de Todos
            </ButtonFunction>
          </Card>
        </motion.div>
    )
}

export default ManagePoints